type Unsubscribe = () => void;

export function getWindow(): Window | null {
  return typeof window === 'undefined' ? null : window;
}

export function getDocument(): Document | null {
  return typeof document === 'undefined' ? null : document;
}

export function addEventListener<Element extends Window, Map extends WindowEventMap, Event extends keyof Map>(
  element: Element,
  event: Event,
  listener: (event: Map[Event]) => unknown,
  options?: boolean | AddEventListenerOptions
): Unsubscribe;
export function addEventListener<Element extends Document, Map extends DocumentEventMap, Event extends keyof Map>(
  element: Element,
  event: Event,
  listener: (event: Map[Event]) => unknown,
  options?: boolean | AddEventListenerOptions
): Unsubscribe;
export function addEventListener<Element extends HTMLElement, Map extends HTMLElementEventMap, Event extends keyof Map>(
  element: Element,
  event: Event,
  listener: (event: Map[Event]) => unknown,
  options?: boolean | AddEventListenerOptions
): Unsubscribe;

export function addEventListener<
  Element extends Window | Document | HTMLElement,
  Map extends WindowEventMap | DocumentEventMap | HTMLElementEventMap,
  Event extends keyof Map & string,
>(
  element: Element,
  event: Event,
  listener: (event: Map[Event]) => unknown,
  options?: boolean | AddEventListenerOptions
): Unsubscribe {
  // @ts-ignore
  element.addEventListener(event, listener, options);

  return () => {
    // @ts-ignore
    element.removeEventListener(event, listener, options);
  };
}

export function addResizeListener(element: Element, listener: ResizeObserverCallback): Unsubscribe {
  const observer = new ResizeObserver(listener);

  observer.observe(element);

  return () => {
    observer.disconnect();
  };
}

export function getWindowMaxScrollY(): number {
  const body = document.body;
  const html = document.documentElement;

  return Math.max(
    0,
    Math.min(
      Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight) -
        window.innerHeight
    )
  );
}
